// Angular
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

// localforage
import * as localforage from 'localforage';

// services
import { ApiService } from '@app/services/api/api.service';

@Component({
  selector: 'oh-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent implements OnInit {
  private data: any;
  public info: any;
  public openHouse: any;

  constructor(private apiService: ApiService, private router: Router) {}

  async ngOnInit() {
    await this.getData();

    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        if (event && event.url === '/welcome' && event.urlAfterRedirects === '/welcome') {
          await this.getData();
        } else if (event && (event.url === '/open-house-select' || event.url === '/login')) {
          this.info = undefined;
        }
      }
    });
  }

  async getData() {
    try {
      this.openHouse = await localforage.getItem('oh-selected-open-house');
      this.data = await this.apiService.getAgentDataFromDatabase();
      this.info = this.data;
    } catch (error) {
      console.error(error);
    }
  }
}
